"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _MerchandiseIds = require("self-service-api/constants/MerchandiseIds");

var _AddOnItem = _interopRequireDefault(require("./optional-items/AddOnItem"));

var _UIGrid = _interopRequireDefault(require("UIComponents/grid/UIGrid"));

var _AccordionTransition = _interopRequireDefault(require("UIComponents/transitions/AccordionTransition"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H1"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _responsiveBreakpoints = _interopRequireDefault(require("../../utils/responsiveBreakpoints"));

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    .col-xs-6 {\n      max-width: 100%;\n      flex-basis: 100%;\n    }\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin-bottom: 8px !important;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledH1 = (0, _styledComponents.default)(_H.default).withConfig({
  displayName: "AddOns__StyledH1",
  componentId: "tdl658-0"
})(_templateObject());
var ButtonGrid = (0, _styledComponents.default)(_UIGrid.default).withConfig({
  displayName: "AddOns__ButtonGrid",
  componentId: "tdl658-1"
})(_templateObject2(), _responsiveBreakpoints.default.tablet(_templateObject3()));

function AddOns(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var stringKey = isOpen ? 'seeFewer' : 'seeMore';
  return _react.default.createElement("div", {
    className: "m-bottom-12"
  }, _react.default.createElement(StyledH1, null, title), subtitle, _react.default.createElement(ButtonGrid, {
    className: "m-top-4"
  }, _react.default.createElement(_AddOnItem.default, {
    merchandiseId: _MerchandiseIds.ADDON_REPORTING
  }), _react.default.createElement(_AddOnItem.default, {
    merchandiseId: _MerchandiseIds.ADDON_ADS_CAPACITY
  }), _react.default.createElement(_AddOnItem.default, {
    merchandiseId: _MerchandiseIds.ADDON_CUSTOM_SSL
  }), _react.default.createElement(_AddOnItem.default, {
    merchandiseId: _MerchandiseIds.ADDON_API
  })), _react.default.createElement(_AccordionTransition.default, {
    open: isOpen
  }, _react.default.createElement(ButtonGrid, null, _react.default.createElement(_AddOnItem.default, {
    merchandiseId: _MerchandiseIds.ADDON_DEDICATED_IP
  }), _react.default.createElement(_AddOnItem.default, {
    merchandiseId: _MerchandiseIds.ADDON_TRANSACTIONAL_EMAIL
  }), _react.default.createElement(_AddOnItem.default, {
    merchandiseId: _MerchandiseIds.ADDON_BRAND_DOMAIN
  }))), _react.default.createElement("div", {
    className: "text-center m-top-2"
  }, _react.default.createElement(_UILink.default, {
    onClick: function onClick() {
      return setIsOpen(!isOpen);
    }
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.calculator.addonsAndServices.addons." + stringKey
  }))));
}

var _default = AddOns;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/bundle-page/AddOns.js
// module id = 779
// module chunks = 5 6